import Link, { LinkTypeMap } from '@mui/material/Link';
import type { OverridableComponent } from '@mui/material/OverridableComponent';

// Exporting MUI <Link> component as a button HTML element
// This is needed to avoid the A11y "anchor" warning in the console
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Link as OverridableComponent<LinkTypeMap<any, 'button'>>;
